import { makeStyles } from '@mui/styles';

export const useHubAllocationsFormStyles = makeStyles((theme) => ({
  allocationPanelWrapper: {
    marginBottom: theme.spacing(2),
    paddingLeft: '28px',
    paddingRight: '24px',
    width: '100%',
    [theme.breakpoints.up('xl')]: {
      width: '50%'
    }
  }
}));
